// extracted by css-extract-rspack-plugin
export default {"fieldError":"FieldError_fieldError__BqdYo"};